import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './App.css';

// Root Element
const root = ReactDOM.createRoot(document.getElementById('root'));

// App rendern
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Service Worker DEAKTIVIERT - Alte SW deregistrieren
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(function(registrations) {
    for(let registration of registrations) {
      registration.unregister();
      console.log('✅ Service Worker deregistriert');
    }
  });
  
  // Alle Caches löschen
  caches.keys().then(function(names) {
    for(let name of names) {
      caches.delete(name);
      console.log('✅ Cache gelöscht:', name);
    }
  });
}

// Online/Offline Status überwachen
window.addEventListener('online', () => {
  console.log('Online-Modus');
});

window.addEventListener('offline', () => {
  console.log('Offline-Modus');
});

// Performance Monitoring (optional)
if (process.env.NODE_ENV === 'production') {
  const reportWebVitals = (metric) => {
    console.log(metric);
  };

  import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
    getCLS(reportWebVitals);
    getFID(reportWebVitals);
    getFCP(reportWebVitals);
    getLCP(reportWebVitals);
    getTTFB(reportWebVitals);
  }).catch(() => {
    // web-vitals nicht verfügbar, ignorieren
  });
}

// Verhindere Zoom durch Doppeltap auf iOS (optional)
let lastTouchEnd = 0;
document.addEventListener('touchend', (event) => {
  const now = Date.now();
  if (now - lastTouchEnd <= 300) {
    event.preventDefault();
  }
  lastTouchEnd = now;
}, false);

// Error Boundary auf globaler Ebene
window.addEventListener('error', (event) => {
  console.error('Globaler Fehler:', event.error);
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('Unbehandelte Promise Rejection:', event.reason);
});